<template>
  <div class="page-download">
    <!--  <div class="page-download-btn">-->
    <!--    <Button :type="'primary'"-->
    <!--      :size="'l'" @click="downloadApp"-->
    <!--    >-->
    <!--      点击立即下载-->
    <!--    </Button>-->
    <!--  </div>-->
  </div>
</template>
<script>
// import Button from '@/ui/button/index';

export default {
  components: {
    // Button,
  },
  props: {},
  data() {
    return {};
  },
  methods: {
    downloadApp() {
      this.$toast('尚未开放下载~ 耐心等等吧~');
    },
  },
  beforeRouteEnter() {
    window.location.replace('https://shanxian.qq.com/download');
  },
};
</script>

<style lang="scss">
.page-download {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page-download-btn {
  width: 80%;
}
</style>
